import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class FileService {
  constructor(private http: HttpClient) {}

  getFile(file: string): Observable<string> {
    return this.http.get(file, { responseType: 'text' });
  }
}
